
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

// Import CSS files with explicit paths
import './index.css';
import './App.css';

console.log('Script execution started in main.tsx');
console.log('Environment:', import.meta.env.MODE);
console.log('Base URL:', import.meta.env.BASE_URL);
console.log('Public URL for assets:', import.meta.env.BASE_URL);

// Find or create the root element
let rootElement = document.getElementById('root');
if (!rootElement) {
  console.log('Root element not found, creating one');
  rootElement = document.createElement('div');
  rootElement.id = 'root';
  document.body.appendChild(rootElement);
}

// Render with comprehensive error handling
try {
  console.log('Creating React root');
  const root = createRoot(rootElement);
  
  console.log('Rendering application');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  console.log('Application rendered successfully');
} catch (error) {
  console.error('Failed to render application:', error);
  
  // If React fails, attempt to show a plain HTML message
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 40px; max-width: 800px; margin: 0 auto; font-family: system-ui, sans-serif; text-align: center;">
        <h1 style="font-size: 24px; margin-bottom: 16px; color: #e11d48;">
          Application Error
        </h1>
        <p style="margin-bottom: 16px; color: #374151;">
          ${error instanceof Error ? error.message : 'Unknown error'}
        </p>
        <p style="color: #6b7280; margin-bottom: 16px;">
          Check the console for more details.
        </p>
        <button onclick="window.location.reload()" 
          style="padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Reload Application
        </button>
      </div>
    `;
  }
}
